
import React from 'react';
import {Box, Grid, TextField, Typography, Button, Autocomplete, List, ListItem, Dialog, ListItemButton, Avatar, MenuItem} from "@mui/material";
import swal from "sweetalert";
import {getAllUsernames, getSingleUser, handleBlockUser, deleteWellnessUser, changePwd, updateUserInfo} from '../../utilityFunctions/WarehouseUtil';
import Colors from "../../components/ui/Colors";
import BlockIcon from '@mui/icons-material/Block';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { useHistory } from "react-router-dom";

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const pwdChangeRequest={};
const userInfoChangeRequest={};

const rolesArray = [
    {
        name: "Administrador",
        value: "ADMIN",
    },
    {
        name: "Montacargas",
        value: "TRANSPORTER",
    },
    {
        name: "Supervisor",
        value: "SUPERVISOR",
    },
    {
        name: "Producción",
        value: "PROD",
    },
    {
        name: "Seguridad",
        value: "SECURITY",
    },
];

export default function ManageUsers(props) {

    const {loginUser} = props;

    let history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const[usernames, setUsernames] = React.useState(null);
    const[username, setUsername] = React.useState(null);
    const[wellnessUser, setWellnessUser] = React.useState(null);

    const[role, setRole] = React.useState("");
    const[name, setName] = React.useState("");
    const[lastName, setLastName] = React.useState("");
    const[idNumber, setIdNumber] = React.useState("");

    React.useEffect(() => {
        const loadInitialValues = async () => {
            await initialValues();
        }
        loadInitialValues();
    }, []);

    const initialValues = async () => {
        
        setLoading(true);
        const response = await getAllUsernames(loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Failed to get users",
                icon: "error",
                button: "OK",
            });
            return;
        }

        setUsernames(response);

    };

    const usernameChange = async (e, value) => {
        if(!value){
            return;
        }

        setUsername(value);

        getlClient(value);
        
    };

    const getlClient = async (value) => {
        setLoading(true);
        const response = await getSingleUser(value, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "No se pudo obtener el usuario",
                icon: "error",
                button: "OK",
            });
            return;
        };
        
        
        setWellnessUser(response);

        setRole(response.role);
        setName(response.name);
        setLastName(response.lastName);
        setIdNumber(response.idNumber);
    };

    const roleChange = (e) => {
        setRole(e.target.value);
        userInfoChangeRequest.role = e.target.value;
    };

    const nameChange = (e) => {
        setName(e.target.value);
        userInfoChangeRequest.name = e.target.value;
    };

    const lastNameChange = (e) => {
        setLastName(e.target.value);
        userInfoChangeRequest.lastName = e.target.value;
    };

    const idNumberChange = (e) => {
        setIdNumber(e.target.value);
        userInfoChangeRequest.idNumber = e.target.value;
    };

    // React.useEffect(() => {
    //     if(wellnessUser){
    //         openActionBox();
    //     }else{
    //         closeActionBox();
    //     }
    // }, [wellnessUser]);

    const[actionBox, setActionBox] = React.useState(false);

    const openActionBox = () => {
        setActionBox(true);
    };

    const closeActionBox = () => {
        setActionBox(false);
    };

    const blockUser = async () => {

        setLoading(true);
        const response = await handleBlockUser({username: wellnessUser.username}, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "No se pudo bloquear el usuario",
                icon: "error",
                button: "OK",
            });
            return;
        }

        setWellnessUser(response);

        console.log(response);

        swal({
            title: "Ok",
            text: "Actualización exitosa",
            icon: "success",
            button: "OK",
        });

    };

    const goToChangeUser = () => {
        history.push({
            pathname: '/admin/change_user_info',
            state: {user: wellnessUser}
        });
    };

    const deleteUser = async () => {


            
        setLoading(true);
        const response = await deleteWellnessUser(username, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "No se pudo eliminar el usuario",
                icon: "error",
                button: "OK",
            });
            return;
        }

        swal({
            title: "Ok",
            text: "Usuario eliminado",
            icon: "success",
            button: "OK",
        });

        initialValues();

    };

    const[changePwdBox, setChangePwdBox] = React.useState(false);
    const[password, setPassword] = React.useState("");
    const openChangePwd = () => {
        setChangePwdBox(true);
    };

    const closeChangePwdBox = () => {
        setChangePwdBox(false);
    };

    const passwordChange = (e) => {
        setPassword(e.target.value);
        pwdChangeRequest.username = username.username;
        pwdChangeRequest.password = e.target.value;
    };

    const handleChangePwd = async () => {

        setLoading(true);
        const response = await changePwd(pwdChangeRequest, loginUser.jwtToken);
        closeChangePwdBox();
        setPassword("");
        pwdChangeRequest.username = "";
        pwdChangeRequest.password = "";
        closeActionBox();
        setLoading(false);
        

        if(!response){
            swal({
                title: "Error",
                text: "No se pudo cambiar la contraseña",
                icon: "error",
                button: "OK",
            });
            return;
        }

        swal({
            title: "Actualización exitosa",
            text: "Contraseña cambiada exitosamente",
            icon: "success",
            button: "OK",
        });

    };

    const handleUpdateUserInfo = async () => {
        setLoading(true);
        const response = await updateUserInfo(userInfoChangeRequest, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "No se pudo actualizar la información del usuario",
                icon: "error",
                button: "OK",
            });
            return;
        }

        swal({
            title: "Actualización exitosa",
            text: "Información actualizada exitosamente",
        });
    };

    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "95%",
                    height: "90%",
                    textAlign: "center",
                    marginTop: {xs: "1.3rem", sm: 0},
                }}
            >
                {loading ? <PuffLoader color={Colors.primary} css={cssLoader} size={100} /> :
                    <>
                    <Grid container direction="row" spacing={1} sx={{justifyContent: "center"}}>
                        {usernames &&
                            <>
                            <Grid item xs={12} sx={{display: "flex", justifyContent: "center"}}>
                                <Autocomplete
                                    sx={{width: {xs: "90%", sm: "80%", md: "60%"}}}
                                    options={usernames}
                                    getOptionLabel={(option) => option.username}
                                    clearOnEscape
                                    autoComplete = {true}
                                    noOptionsText = {"username not found"}
                                    fullWidth
                                    onChange={usernameChange}
                                    renderInput={(params) => (
                                        <TextField  {...params} label="Username" variant="standard" />
                                    )}
                                />
                            </Grid>
                            </>
                        }
                        {wellnessUser &&
                        <>
                            <Grid item xs={12} sm={6} md={6} sx={{mt: "2rem"}}>
                                <Grid container direction="column" sx={{width: "100%"}}>
                                    <Grid item sx={{display: "flex", justifyContent: "start", alignItems: "center", width: "100%"}}>
                                        <Typography variant="body2" sx={{textAlign: "start", fontSize: "0.7rem", color: "GrayText"}}>Estado usuario</Typography>
                                    </Grid>
                                    <Grid item sx={{display: "flex", justifyContent: "start", alignItems: "center", width: "100%"}}>
                                        <Typography variant="body2" sx={{textAlign: "start", color: "black"}}>{wellnessUser.accountNonLocked ? "Activo" : "Bloqueado"}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} sx={{mt: "2rem"}}>
                                <Grid container direction="column" sx={{width: "100%"}}>
                                    <Grid item sx={{display: "flex", justifyContent: "start", alignItems: "center", width: "100%"}}>
                                        <Typography variant="body2" sx={{textAlign: "start", fontSize: "0.7rem", color: "GrayText"}}>Intentos fallidos</Typography>
                                    </Grid>
                                    <Grid item sx={{display: "flex", justifyContent: "start", alignItems: "center", width: "100%"}}>
                                        <Typography variant="body2" sx={{textAlign: "start", color: "black"}}>{wellnessUser.failedAttempt}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    sx={{textAlign: "start"}}
                                    variant="standard"
                                    fullWidth={true}
                                    id="role"
                                    name="role"
                                    select
                                    label={<Typography variant="body2">Perfil</Typography>}
                                    value={role}
                                    onChange={(e)=>roleChange(e)}
                                    autoComplete="off"
                                >
                                    {rolesArray.map((el) => (
                                        <MenuItem key={el.value} value={el.value}>
                                            {el.name}
                                        </MenuItem>
                                    ))}
                                </TextField> 
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    variant="standard"
                                    fullWidth={true}
                                    id="name"
                                    name="name"
                                    label={<Typography variant="body2">Nombre</Typography>}
                                    value={name}
                                    onChange={(e)=> nameChange(e)}
                                    autoComplete="off"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    variant="standard"
                                    fullWidth={true}
                                    id="lastName"
                                    name="lastName"
                                    label={<Typography variant="body2">Apellidos</Typography>}
                                    value={lastName}
                                    onChange={(e)=> lastNameChange(e)}
                                    autoComplete="off"
                                />
                            </Grid>
                            {/* <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    variant="standard"
                                    fullWidth={true}
                                    id="idNumber"
                                    name="idNumber"
                                    label={<Typography variant="body2">Número de Identificación</Typography>}
                                    value={idNumber}
                                    onChange={(e)=> idNumberChange(e)}
                                    autoComplete="off"
                                />
                            </Grid> */}
                            <Grid item xs={6} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2rem", marginBottom: "1.5rem"}}>
                                <Button onClick={handleUpdateUserInfo} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                    Actualizar información
                                </Button>
                            </Grid>
                            <Grid item xs={6} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2rem", marginBottom: "1.5rem"}}>
                                <Button onClick={openActionBox} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                    Administrar usuario
                                </Button>
                            </Grid>
                        </>
                        
                        }
                    </Grid>

                    <Dialog open={actionBox} onClose={closeActionBox}
                        sx={{
                            "& .MuiDialog-container": {
                                "& .MuiPaper-root": {
                                    width: {xs: "80%", sm: "40%", md: "50%"},
                                    padding: "1.5rem", // Add padding to the dialog
                                    borderRadius: "16px", // Softer corners
                                },
                            },
                        }}
                        >
                        {wellnessUser &&
                            <List sx={{width: "100%",}}>
                                <ListItem disablePadding sx={{marginBottom: "0.3rem", marginTop: "0.3rem"}}>
                                    <ListItemButton  onClick={blockUser}>
                                        <Grid container>
                                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                <Avatar sx={{ backgroundColor: Colors.primary, width: "3rem", height: "3rem" }}>
                                                    <BlockIcon sx={{ fontSize: "1.5remrem", color: "white" }} />
                                                </Avatar>
                                            </Grid>
                                            <Grid item xs={9} sm={9} md={9} sx={{display: "flex", justifyContent: "start", alignItems: "center"}}>
                                                <Typography variant="h6" sx={{ml:{xs: "0.8rem", sm: "1rem"}}}>{wellnessUser.accountNonLocked ? "Bloquear" : "Desbloquear"}</Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItemButton>
                                </ListItem>
                                {false &&
                                <ListItem disablePadding sx={{marginBottom: "0.3rem", marginTop: "0.3rem"}}>
                                    <ListItemButton  onClick={goToChangeUser}>
                                        <Grid container>
                                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                <Avatar sx={{ backgroundColor: Colors.primary, width: "3rem", height: "3rem" }}>
                                                    <ChangeCircleIcon sx={{ fontSize: "1.5remrem", color: "white" }} />
                                                </Avatar>
                                            </Grid>
                                            <Grid item xs={9} sm={9} md={9} sx={{display: "flex", justifyContent: "start", alignItems: "center"}}>
                                                <Typography variant="h6" sx={{ml:{xs: "0.8rem", sm: "1rem"}}}>{"Change Info"}</Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItemButton>
                                </ListItem>
                                }
                                <ListItem disablePadding sx={{marginBottom: "0.3rem", marginTop: "0.3rem"}}>
                                    <ListItemButton  onClick={openChangePwd}>
                                        <Grid container>
                                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                <Avatar sx={{ backgroundColor: Colors.primary, width: "3rem", height: "3rem" }}>
                                                    <ChangeCircleIcon sx={{ fontSize: "1.5remrem", color: "white" }} />
                                                </Avatar>
                                            </Grid>
                                            <Grid item xs={9} sm={9} md={9} sx={{display: "flex", justifyContent: "start", alignItems: "center"}}>
                                                <Typography variant="h6" sx={{ml:{xs: "0.8rem", sm: "1rem"}}}>{"Cambiar contraseña"}</Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItemButton>
                                </ListItem>
                                {false &&
                                <ListItem disablePadding sx={{marginBottom: "0.3rem", marginTop: "0.3rem"}}>
                                    <ListItemButton  onClick={deleteUser}>
                                        <Grid container>
                                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                <Avatar sx={{ backgroundColor: Colors.primary, width: "3rem", height: "3rem" }}>
                                                    <HighlightOffIcon sx={{ fontSize: "1.5remrem", color: "white" }} />
                                                </Avatar>
                                            </Grid>
                                            <Grid item xs={9} sm={9} md={9} sx={{display: "flex", justifyContent: "start", alignItems: "center"}}>
                                                <Typography variant="h6" sx={{ml:{xs: "0.8rem", sm: "1rem"}}}>{"Delete User"}</Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItemButton>
                                </ListItem>
                                }
                            </List>
                        }
                    </Dialog>

                    <Dialog open={changePwdBox} onClose={closeChangePwdBox}
                        sx={{
                            "& .MuiDialog-container": {
                                "& .MuiPaper-root": {
                                    width: {xs: "80%", sm: "40%", md: "30%"},
                                    // height: "40%",
                                    padding: "1.5rem", // Add padding to the dialog
                                    borderRadius: "16px", // Softer corners
                                },
                            },
                        }}
                    >
                        <Grid container spacing={1} sx={{width: "100%", height: "100%", alignItems: "center", justifyContent: "center"}}>   
                            <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                                <Typography variant="h5">Nueva contraseña</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0.2rem"}}>
                                <TextField
                                    sx={{width: "80%"}}
                                    variant="standard"
                                    fullWidth={true}
                                    label={<Typography variant="body2">Nueva contraseña</Typography>}
                                    value={password}
                                    onChange={(e)=> passwordChange(e)}
                                    autoComplete="off"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2rem", marginBottom: "1.5rem"}}>
                                <Button onClick={handleChangePwd} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                    Cambiar contraseña
                                </Button>
                            </Grid>
                        </Grid>
                    </Dialog>
                    </>
                    
                }
            </Box>
        </Box>
    )
}
